"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _FormattedList = _interopRequireDefault(require("I18n/components/FormattedList"));

var AppIntegrations = function AppIntegrations(_ref) {
  var integrations = _ref.integrations;
  return _react.default.createElement(_FormattedList.default, null, integrations.sort().map(function (integration) {
    return _react.default.createElement("span", {
      key: integration
    }, integration);
  }).toArray());
};

AppIntegrations.propTypes = {
  integrations: _reactImmutableProptypes.default.set.isRequired
};
var _default = AppIntegrations;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/AppIntegrations.js
// module id = 820
// module chunks = 209 210 211 212